module.exports = __webpack_public_path__ + "media/images/lb/652-ea85fcee6145f2002623072b3db34084.svg";